<template>
  <!-- style="width:385px;height:267px" -->
  <div class="flex_div">
    <div class="middle_top" style="padding-bottom: 20px">
      <i>预警监测</i>
      <div class="flex_bet text-center" style="height: 60px">
        <div
          v-for="(item, index) in getWarningStatisticsData"
          :key="index"
          :style="{
            background:
              index == '2'
                ? 'linear-gradient(180deg,rgba(255,98,99,0.8), #ff3c3c)'
                : 'linear-gradient(180deg,#1c3667, #325ba6)',
            width: '30%',
            padding: '4px 0px;',
          }"
        >
          <p>
            <span class="digital">{{ item.number }}</span>
          </p>
          <p
            :style="{
              color: index != '2' ? '#93BBF3' : '#fff',
              fontSize: '14px',
            }"
          >{{ item.typeName }}</p>
          <!-- <p style="color: #fff; font-size: 14px">{{ item.typeName }}</p> -->
        </div>
        <!-- <div
          style="
            width: 30%;
            background: rgb(255, 60, 60, 0.4);
            padding: 4px 0px;
          "
        >
          <p style="color: #3D7FFF; olor: #3D7FFF; font-size: 16px">337</p>
          <p style="color: #fff; font-size: 14px">已处理预警数</p>
        </div>
        <div
          style="
            width: 30%;
            background: rgb(255, 60, 60, 0.4);
            padding: 4px 0px;
          "
        >
          <p style="color: #fff; olor: #3D7FFF; font-size: 16px">3</p>
          <p style="color: #fff; font-size: 14px">未处理预警数</p>
        </div>-->
      </div>
      <div style="width: 100%; text-align: center; height: 55%">
        <li
          class="flex-bet m-top"
          style="
            color: #95adce;
            display: flex;
            justify-content: space-between;
            text-align: center;
          "
        >
          <span style="flex: 1">事件名称</span>
          <span style="flex: 1">预警时间</span>
          <span style="flex: 1">地点</span>
          <span style="flex: 1">状态</span>
        </li>
        <div style="overflow: hidden; height: 87%">
          <div>
            <!-- <li
              class="flex-bet safeData"
              v-for="(item, index) in getInOutAlarmRecordListData"
              :key="index"
            >
              <span :title="item.alarmName" class="text-overflow">{{
                item.alarmName
              }}</span>
              <span :title="item.createTime" class="text-overflow">{{
                item.createTime
              }}</span>
              <span :title="item.alarmArea" class="text-overflow">{{
                item.alarmArea
              }}</span>
              <span class="text-overflow">{{
                item.dealStatus == "1" ? "已处理" : "未处理"
              }}</span>
            </li>-->

            <textData style="color: #95adce" :length="4" :textData="getInOutAlarmRecordListData">
              <template v-slot:alarmName="slotProps">
                <span
                  class="text-overflow"
                  style="flex: 1; height: 30px; line-height: 30px"
                >{{ slotProps.val }}</span>
              </template>
              <template v-slot:createTime="slotProps">
                <span
                  :title="slotProps.val"
                  class="text-overflow"
                  style="flex: 1; height: 30px; line-height: 30px"
                >{{ slotProps.val }}</span>
              </template>
              <template v-slot:alarmArea="slotProps">
                <span
                  :title="slotProps.val"
                  class="text-overflow"
                  style="flex: 1; height: 30px; line-height: 30px"
                >{{ slotProps.val }}</span>
              </template>
              <template v-slot:dealStatus="slotProps">
                <span
                  class="text-overflow"
                  style="flex: 1; height: 30px; line-height: 30px"
                >{{ slotProps.val.dealStatus == "1" ? "已处理" : "未处理" }}</span>
              </template>
            </textData>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/home.scss";
import textData from "@/components/textData.vue";
export default {
  data() {
    return {
      getWarningStatisticsData: [],
      getInOutAlarmRecordListData: [],
      // 计时器
      warnTime: null,
      distance1: 0,
    };
  },
  components: {
    textData,
  },
  created() {
    // 预警监测数量统计
    this.getWarningStatistics();
    // 预警列表
    this.getInOutAlarmRecordList();
    // this.warnScrollUp();
  },
  mounted() { },
  methods: {
    // 预警监测数量统计
    getWarningStatistics() {
      this.$api.getWarningStatistics().then((res) => {
        if (res.code == "200") {
          this.getWarningStatisticsData = res.data;
        }
      });
    },
    // 预警列表
    getInOutAlarmRecordList() {
      this.$api.getInOutAlarmRecordList({ type: "4" }).then((res) => {
        if (res.code == "200") {
          if (res.data && res.data.length > 0) {
            res.data.forEach((item) => {
              this.getInOutAlarmRecordListData.push({
                alarmName: item.alarmName,
                createTime: item.createTime,
                alarmArea: item.alarmArea,
                dealStatus: item.dealStatus,
              });
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex_div {
  width: 50%;
  height: 33%;
}
.digital {
  font-family: digital;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
}
.contBox {
  height: 100%;
}
</style>